import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ExportScheduleForm } from '@modules/jupiter/home/@components/export-scheduling-management/export-schedule.types';

type ListExportSchedulesResponse = {
  schedules: ExportScheduleForm[];
};

type ScheduleResponse = {
  schedule: ExportScheduleForm;
};

@Injectable({ providedIn: 'root' })
export class ExportScheduleService {
  private readonly httpClient = inject(HttpClient);

  list(savedViewId: number): Observable<ExportScheduleForm[]> {
    return this.httpClient
      .get<ListExportSchedulesResponse>(this.getSchedulesPath(savedViewId))
      .pipe(map((response) => response?.schedules ?? []));
  }

  create(savedViewId: number, schedule: ExportScheduleForm): Observable<ExportScheduleForm> {
    return this.httpClient
      .post<ScheduleResponse>(this.getSchedulesPath(savedViewId), schedule)
      .pipe(map((response) => response.schedule));
  }

  update(savedViewId: number, schedule: ExportScheduleForm): Observable<ExportScheduleForm> {
    const scheduleId = schedule?.id;

    return this.httpClient
      .patch<ScheduleResponse>(`${this.getSchedulesPath(savedViewId)}/${scheduleId}`, schedule)
      .pipe(map((response) => response.schedule));
  }

  delete(savedViewId: number, scheduleId: number): Observable<void> {
    return this.httpClient.delete<void>(`${this.getSchedulesPath(savedViewId)}/${scheduleId}`);
  }

  get(savedViewId: number, scheduleId: number): Observable<ExportScheduleForm> {
    return this.httpClient.get<ExportScheduleForm>(`${this.getSchedulesPath(savedViewId)}/${scheduleId}`);
  }

  private getSchedulesPath(savedViewId: number): string {
    return `saved_views/${savedViewId}/schedules`;
  }
}
